import React, { useCallback } from "react";
import {
	AnchorPositioningFeedback,
	PinAnchorState,
} from "../../../../state/pin-anchor-state";
import PinAnchorPositioning from "./pin-anchor-positioning";

export interface PinAnchorProps {
	state: PinAnchorState;
}

export default function PinAnchor(props: PinAnchorProps) {
	const propsSetSelection = props.state.setSelection;

	const close = useCallback(() => {
		propsSetSelection(null);
	}, [propsSetSelection]);

	if (props.state.selection === null) {
		return null;
	}

	const device = props.state.selection;

	return (
		<PinAnchorPositioning
			onClose={close}
			deviceID={device.id}
			deviceModel={device.model}
			positioningFeedback={props.state.positioningFeedback}
			isLoading={props.state.loading}
			disableNext={
				props.state.location === null ||
				props.state.loading ||
				props.state.positioningFeedback ===
					AnchorPositioningFeedback.NoSite
			}
			onNext={props.state.submit}
		/>
	);
}
